module.exports = __webpack_public_path__ + "static/media/error.727ebb21.svg";